import {closeCurrentDialog, FormSubmitHandler, showNotification} from 'platform/components';

import {
  TestDriveCalendarSettings,
  useUpdateTestDriveCalendarSettingsMutation,
} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {ApiError, useQueryState} from 'shared/web';

import {PARAM} from './useTestDriveCalendarControl';

/** A settings save is a filter change like any other, so it resets the page the same way. */
export const useTestDriveCalendarSettingsSubmit = () => {
  const [, , clearPage] = useQueryState(PARAM.page);
  const [updateSettings, {isLoading}] = useUpdateTestDriveCalendarSettingsMutation();

  const submit: FormSubmitHandler<TestDriveCalendarSettings> = async (values, setErrors) => {
    await updateSettings({
      updateTestDriveCalendarSettingsRequestBody: {
        ...values,
        branchOverrides: values.branchOverrides.filter((override) =>
          values.branchIds.includes(override.branchId)
        ),
      },
    })
      .unwrap()
      .then(() => {
        showNotification.success(i18n.t('general.notifications.successfullyUpdated'));
        clearPage();
        closeCurrentDialog();
      })
      .catch((error: ApiError) => handleApiError(error, {setErrors}));
  };

  return {submit, isLoading};
};
